<template>
    <nav v-if="totalPages > 1" class="pagination" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li class="pagination-prev">
                <button class="pagination-previous"
                        @click.prevent="changePage(currentPage - 1)"
                        v-bind:disabled="currentPage <= 1 ? 'disabled' : false"
						aria-label="Previous Page">
                    <span class="icon-icon-ArrowRight"></span>
                </button>
            </li>
            <li>
				<p>{{ currentPage }} of {{ totalPages }}</p>
            </li>
            <li class="pagination-next">
                <button class="pagination-next"
                        @click.prevent="changePage(currentPage + 1)"
                        v-bind:disabled="currentPage >= totalPages ? 'disabled' : false"
						aria-label="Next Page">
                    <span class="icon-icon-ArrowRight"></span>
                </button>
            </li>
        </ul>

		<p>View our full <a href="/find-an-agent/agent-directory">Agent Directory</a></p>
    </nav>
</template>

<script>
    import $ from 'jquery';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
        props: ['totalResults'],
		data: function () {
			return {
				pageSize: 10,
				pages: [],
				startPage: 0,
				endPage: 0,
                totalPages: 0
			}
		},
		computed: mapState({
            currentPage: state => state.listing.currentPage,
		}),
		watch: {
            totalResults: {
				handler: function handler(newProp, oldProp) {
                    this.totalPages = Math.ceil(newProp / this.pageSize);
					this.createStartEndPages();
                },
                deep: true,
                immediate: true
            }
		},
		mounted() {
			this.createStartEndPages();
		},
		methods: {
            ...mapMutations('listing', { updatePageNumber: 'updatePageNumber' }),
			createStartEndPages() {
                this.startPage = this.currentPage - 2;
                this.endPage = this.currentPage + 2;

				if (this.startPage <= 0) {
					this.endPage -= this.startPage - 1;
					this.startPage = 1;
				}

				if (this.endPage > this.totalPages) {
					this.endPage = this.totalPages;

					if (this.endPage > 10) {
						this.startPage = this.endPage - 9;
					}
				}

				this.setPages();
			},
            isCurrentPage(page) {
                return this.currentPage === page;
            },
            changePage(page) {
				if (page > this.totalPages) {
					page = this.totalPages;
				}

				$('html, body').animate({
                    scrollTop: $('#agent-map-section').offset().top - 160
                }, 1000);

                this.createStartEndPages();
                this.updatePageNumber(page);
			},
			setPages() {
				let from = this.startPage;
				let to = this.endPage;
				this.pages = [];

				while (from <= to) {
					this.pages.push(from);
					from++;
				}
			}
        }
    }
</script>